import { __assign, __awaiter, __generator } from "tslib";
import { CampaignTracker } from '@amplitude/analytics-client-common';

var PluginCampaignTracker =
/** @class */
function () {
  function PluginCampaignTracker(apiKey, storage, options) {
    this.campaignTracker = new CampaignTracker(apiKey, __assign(__assign({}, options), {
      trackPageViews: false,
      track:
      /* istanbul ignore next */
      function track() {
        return Promise.resolve();
      },
      onNewCampaign:
      /* istanbul ignore next */
      function onNewCampaign() {
        return function () {
          return undefined;
        };
      },
      storage: storage
    }));
  }

  PluginCampaignTracker.prototype.createCampaignEvent = function (currentCampaign) {
    return this.campaignTracker.createCampaignEvent(currentCampaign);
  };

  PluginCampaignTracker.prototype.onPageChange = function (callback) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, currentState;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = callback;
            return [4
            /*yield*/
            , this.getCurrentState()];

          case 1:
            return [4
            /*yield*/
            , _a.apply(void 0, [_b.sent()])];

          case 2:
            _b.sent();

            return [4
            /*yield*/
            , this.getCurrentState()];

          case 3:
            currentState = _b.sent();

            if (currentState.isNewCampaign) {
              void this.campaignTracker.saveCampaignToStorage(currentState.currentCampaign);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PluginCampaignTracker.prototype.getCurrentState = function () {
    return __awaiter(this, void 0, void 0, function () {
      var currentCampaign, isNewCampaign, _a, _b, _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            return [4
            /*yield*/
            , this.campaignTracker.parser.parse()];

          case 1:
            currentCampaign = _d.sent();
            _b = (_a = this.campaignTracker).isNewCampaign;
            _c = [currentCampaign];
            return [4
            /*yield*/
            , this.campaignTracker.getCampaignFromStorage()];

          case 2:
            isNewCampaign = _b.apply(_a, _c.concat([_d.sent(), true]));
            return [2
            /*return*/
            , {
              isNewCampaign: isNewCampaign,
              currentCampaign: currentCampaign
            }];
        }
      });
    });
  };

  return PluginCampaignTracker;
}();

export { PluginCampaignTracker };